import React from "react";
import { X, Copy } from "lucide-react";
import { FaWhatsapp, FaXTwitter, FaFacebook, FaLinkedin, FaInstagram} from "react-icons/fa6";

export default function Modal({ isOpen, onClose, shareLink, title = "Mock Interview" }) {
  if (!isOpen) return null;

  const handleCopy = () => {
    navigator.clipboard.writeText(shareLink);
    alert("Link copied to clipboard!");
  };

  const shareText = encodeURIComponent(`I just challenged myself with Zepcruit's AI Mock Interview;
because opportunities favour those who show up prepared!! #Zepcruit #ReadyToHire
check it out here:`);
  const encodedLink = encodeURIComponent(shareLink);

  const socialLinks = [
    { icon: <FaWhatsapp size={22} />, url: `https://wa.me/?text=${shareText}%0A%0A${encodedLink}` },
    { icon: <FaFacebook size={22} />, url: `https://www.facebook.com/sharer/sharer.php?u=${encodedLink}` },
    { icon: <FaXTwitter size={22} />, url: `https://twitter.com/intent/tweet?text=${shareText}&url=${encodedLink}` },
    { icon: <FaLinkedin size={22} />, url: `https://www.linkedin.com/shareArticle?mini=true&url=${encodedLink}&title=${shareText}` },
    // { icon: <FaTelegramPlane size={22} />, url: `https://t.me/share/url?url=${encodedLink}&text=${shareText}` },
    { icon: <FaInstagram size={22} />, url: "#" }, // Instagram doesn't have direct share links
  ];

  return (
    <div className="fixed inset-0 z-50 flex justify-center items-center bg-black bg-opacity-50">
      <div className="bg-white rounded-2xl shadow-lg w-[475px] max-w-[90%] p-6 relative">
        {/* Close button */}
        <button onClick={onClose} className="absolute top-4 right-4 text-gray-500 hover:text-gray-700">
          <X size={20} />
        </button>

        {/* Title */}
        <h2 className="text-lg font-semibold text-gray-900">Share Mock Interview</h2>
        <p className="text-sm text-gray-500 mb-4">via Zepcruit</p>

        {/* Link Box */}
        <div className="bg-gray-100 flex items-center justify-between rounded-lg p-3 mb-5">
          <a
            href={shareLink}
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 text-sm truncate hover:underline"
          >
            {shareLink}
          </a>
          <button
            onClick={handleCopy}
            className="bg-white border border-gray-300 text-gray-700 rounded-md px-3 py-1 flex items-center gap-1 hover:bg-gray-50"
          >
            <Copy size={16} />
            <span className="text-sm font-medium">Copy</span>
          </button>
        </div>

        {/* Social Media Section */}
        <p className="text-sm text-gray-600 mb-3">Share on social media</p>
        <div className="flex justify-between px-3 mb-6">
          {socialLinks.map((s, idx) => (
            <a
              key={idx}
              href={s.url}
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-600 hover:text-primary-color-900 transition-colors"
            >
              {s.icon}
            </a>
          ))}
        </div>

        {/* Cancel Button */}
        <button
          onClick={onClose}
          className="w-full py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-100 font-medium"
        >
          Cancel
        </button>
      </div>
    </div>
  );
}
